import { Box, Typography } from '@mui/material';
import CustomCard from 'components/cmn/CustomCard';
import useWidth from 'hooks/useWidth';
import { ICodeItem } from 'interface/project/projectInfo';
import { memo } from 'react';
import { useNavigate } from 'react-router-dom';

interface IProjectSelectTypeProps {
  type: ICodeItem;
}
function ProjectSelectType({ type }: IProjectSelectTypeProps): JSX.Element {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate('/admin/project/enter-information', {
      state: { codeValue: type.codeValue },
    });
  };
  const width = useWidth();
  const isPc = ['lg', 'xl'].includes(width);
  const isTablet = ['md'].includes(width);

  let dynamicWidth = '50%';
  if (isPc) {
    dynamicWidth = '50%';
  } else if (isTablet) {
    dynamicWidth = '80%';
  } else {
    dynamicWidth = '100%';
  }
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <CustomCard
        border
        sx={{ backgroundColor: '#d9d9d9', width: dynamicWidth, cursor: 'pointer' }}
        content
        contentSX={{
          flex: '1 0 auto',
          height: 100,
          padding: 2,
          '&:last-child': {
            paddingBottom: 2,
          },
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        onClick={handleClick}
      >
        <Typography typography="s20w700" sx={{ textAlign: 'center' }}>
          {type?.codeName} 프로젝트 생성
        </Typography>
      </CustomCard>
    </Box>
  );
}

export default memo(ProjectSelectType);
